import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWall2Down: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowWall2Down"><Path fillRule="evenodd" clipRule="evenodd" d="M13 3V15.5858L16.25 12.3358L17.6642 13.75L12.4142 19H20V21H4V19H11.5858L6.33579 13.75L7.75 12.3358L11 15.5858V3H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWall2Down;
